// ============================================================
// Datei: src/pages/Login.jsx
// PURPOSE:
// Login-Seite + Anzeige der Verifikations-Meldung
// aufgebaut wie Register und Home
// ============================================================

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Api from "../Api";
import "../styles/login.css";

const Login = () => {
	const [credentials, setCredentials] = useState({ username: "", password: "" });
	const [message, setMessage] = useState(null);
	const [verifiedStatus, setVerifiedStatus] = useState(null);

	const navigate = useNavigate();
	const location = useLocation();
	const usernameRef = useRef(null);

	useEffect(() => {
		setTimeout(() => {
			usernameRef.current?.focus();
		}, 100);

		const params = new URLSearchParams(location.search);
		const status = params.get("verified");

		if (status) {
			setVerifiedStatus(status);

			if (status === "success") {
				setTimeout(() => {
					usernameRef.current?.focus();
				}, 150);
			}
		}
	}, [location]);

	const handleChange = (e) => {
		setCredentials({ ...credentials, [e.target.name]: e.target.value });
		if (message?.type === "error") setMessage(null);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			const response = await Api.post("/auth/login", credentials);
			const data = response.data;

			localStorage.setItem("token", data.token);
			localStorage.setItem("role", data.role);
			localStorage.setItem("department", data.department || "");
			localStorage.setItem("volunteerId", data.id);
			localStorage.setItem("username", credentials.username);

			if (data.role === "ADMIN") {
				navigate("/admin");
			} else if (data.role === "OK") {
				const department = data.department?.toLowerCase();
				const allowed = [
					"bar",
					"chai",
					"hang",
					"infostand",
					"kasse",
					"infrastruktur",
					"caipibar",
					"kaffimobil",
					"sarasani",
					"deko",
					"food",
					"shuttle",
					"awareness",
					"umweltambiente",
					"kindernami",
					"parkplatz",
					"programm",
					"kommunikation",
					"kulturgeschichte",
					"administration"
				];

				if (department && allowed.includes(department)) {
					navigate(`/ressort/${department}`);
				} else {
					setMessage({ type: "error", text: "Fehler: Ungültiges Ressort!" });
				}
			} else {
				navigate("/deployment");
			}
		} catch (err) {
			setMessage({
				type: "error",
				text:
					err.response?.status === 401 || err.response?.status === 403
						? "Login fehlgeschlagen: Benutzername oder Passwort falsch."
						: "Unerwarteter Fehler."
			});
		}
	};

	const renderVerificationBox = () => {
		if (!verifiedStatus) return null;

		let title = "";
		let text = "";

		if (verifiedStatus === "success") {
			title = "E-Mail bestätigt 🎉";
			text = "Du kannst dich jetzt einloggen.";
		} else if (verifiedStatus === "expired") {
			title = "Token abgelaufen";
			text = "Bitte fordere eine neue Bestätigung an.";
		} else if (verifiedStatus === "invalid") {
			title = "Ungültiger Bestätigungslink";
			text = "Bitte erneut versuchen.";
		}

		return (
			<div className="verify-box">
				<h2>{title}</h2>
				<p>{text}</p>
			</div>
		);
	};

	return (
		<main
			className="login-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_login.png`}
		>
			<div className="login-card-column">
				{renderVerificationBox()}

				<div className="login-card">
					<h2 className="login-heading">Login</h2>

					<form onSubmit={handleSubmit} className="login-form">
						<input
							ref={usernameRef}
							type="text"
							name="username"
							placeholder="vorname.nachname"
							onChange={handleChange}
							value={credentials.username}
							required
							className="login-input"
						/>

						<input
							type="password"
							name="password"
							placeholder="Passwort"
							onChange={handleChange}
							value={credentials.password}
							required
							className="login-input"
						/>

						<div className="forgot-password-link-wrapper">
							<Link to="/forgot-password" className="forgot-password-link">
								Passwort vergessen?
							</Link>
						</div>

						<button type="submit" className="login-button">
							Login
						</button>

						{message && (
							<div className={message.type === "success" ? "login-success" : "login-error"}>
								{message.text}
							</div>
						)}
					</form>
				</div>
			</div>
		</main>
	);
};

export default Login;